import C from "../../../@babel/runtime/helpers/esm/defineProperty.mjs";
import d from "../../../@babel/runtime/helpers/esm/objectSpread2.mjs";
import * as P from "react";
import { toArray as U } from "../utils/commonUtil.mjs";
import { injectPropsWithOption as b } from "../utils/valueUtil.mjs";
function l(i, o) {
  return U(i).join("").toUpperCase().includes(o);
}
const E = function(i, o, n, e, p) {
  return P.useMemo(function() {
    if (!n || e === !1)
      return i;
    var u = o.options, m = o.label, j = o.value, f = [], h = typeof e == "function", a = n.toUpperCase(), s = h ? e : function(r, t) {
      return p ? l(t[p], a) : t[u] ? l(t[m !== "children" ? m : "label"], a) : l(t[j], a);
    }, c = h ? function(r) {
      return b(r);
    } : function(r) {
      return r;
    };
    return i.forEach(function(r) {
      if (r[u]) {
        var t = s(n, c(r));
        if (t)
          f.push(r);
        else {
          var v = r[u].filter(function(y) {
            return s(n, c(y));
          });
          v.length && f.push(d(d({}, r), {}, C({}, u, v)));
        }
        return;
      }
      s(n, c(r)) && f.push(r);
    }), f;
  }, [i, e, p, n, o]);
};
export {
  E as default
};
//# sourceMappingURL=useFilterOptions.mjs.map
